
var content = require("!!../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/index.js!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--7-2!../../../node_modules/.pnpm/sass-loader@8.0.2_sass@1.59.3_webpack@4.46.0_webpack-cli@3.3.12_webpack@4.46.0__/node_modules/sass-loader/dist/cjs.js??ref--7-3!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/index.js??vue-loader-options!./HomeDesktop.vue?vue&type=style&index=0&id=53f6a4c6&prod&lang=scss&scoped=true&");

if(typeof content === 'string') content = [[module.id, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = require("!../../../node_modules/.pnpm/style-loader@0.23.1/node_modules/style-loader/lib/addStyles.js")(content, options);

if(content.locals) module.exports = content.locals;

if(module.hot) {
	module.hot.accept("!!../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/index.js!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--7-2!../../../node_modules/.pnpm/sass-loader@8.0.2_sass@1.59.3_webpack@4.46.0_webpack-cli@3.3.12_webpack@4.46.0__/node_modules/sass-loader/dist/cjs.js??ref--7-3!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/index.js??vue-loader-options!./HomeDesktop.vue?vue&type=style&index=0&id=53f6a4c6&prod&lang=scss&scoped=true&", function() {
		var newContent = require("!!../../../node_modules/.pnpm/css-loader@1.0.1_webpack@4.46.0/node_modules/css-loader/index.js!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??ref--7-2!../../../node_modules/.pnpm/sass-loader@8.0.2_sass@1.59.3_webpack@4.46.0_webpack-cli@3.3.12_webpack@4.46.0__/node_modules/sass-loader/dist/cjs.js??ref--7-3!../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@1.0.1_webpack@4.46.0__handlebars@4.7.7_lodash@4.17.21_vue-templ_mtpkf7urruevj4gqqv3dlwyrx4/node_modules/vue-loader/lib/index.js??vue-loader-options!./HomeDesktop.vue?vue&type=style&index=0&id=53f6a4c6&prod&lang=scss&scoped=true&");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}